import { PayoutsResponse } from '@ezugi/types';
import { api, handleError } from '@ezugi/utils';
import { ClientError, HTTPError } from '@ezugi/utils/src/http/errors';

import { configActions } from '../store/actions';
import { authSelector, gameSelector } from '../store/selectors';
import { RootState } from '../store/types';
import { API_PREFIX } from '../util/apiPrefix';
import { logClientError } from './logUtils';

const VITE_API_URL = import.meta.env.VITE_API_URL ?? '';
const VITE_API_FETCH_PAYOUTS = import.meta.env.VITE_API_FETCH_PAYOUTS;

const URL = `${VITE_API_URL}${API_PREFIX}${VITE_API_FETCH_PAYOUTS}`;

export const fetchPayouts = (params: string) => api.get<PayoutsResponse>(`${URL}?${params}`);

export const getPayouts = async (state: RootState, raw: boolean = true) => {
  const { gameId } = gameSelector(state);

  return getPayoutsForGameId(state, gameId, raw);
};

export const getPayoutsForGameId = async (state: RootState, gameId: string | number, raw: boolean = true) => {
  const { identifier } = authSelector(state) ?? { identifier: null };

  return fetchPayouts(
    `game_id=${gameId}&identifier=${identifier}${raw ? '&raw=true' : ''}`
  );
};

export const handlePayoutsError = (error: HTTPError | ClientError) => handleError({
  error,
  failAction: configActions.config.update,
  options: {
    clientErrorHandler: logClientError,
    payloadKey: 'payouts',
  },
});
